import { gql } from '@apollo/client'
import { SmartMutation } from '../SmartMutation'
import {
  InitializeEmptyBatch,
  InitializeEmptyBatchVariables,
  InitializeEmptyBatch_initializeEmptyBatch
} from './types/InitializeEmptyBatch'

export const SM_INIT_EMPTY_BATCH: SmartMutation<
  InitializeEmptyBatchVariables,
  InitializeEmptyBatch,
  InitializeEmptyBatch_initializeEmptyBatch
> = {
  mutation: gql`
    mutation InitializeEmptyBatch($importedFromUrl: String!) {
      initializeEmptyBatch(importedFromUrl: $importedFromUrl) {
        batchId
        workspaceId
      }
    }
  `,
  extract({ initializeEmptyBatch }) {
    return initializeEmptyBatch
  }
}
